export const loadLib = (url, idTag) => {
  return new Promise((resolve, reject) => {
    globalThis.idTagDelio = idTag;
    const script = globalThis.document.createElement("script");
    script.src = url;
    script.id = "initWalmeric";
    script.async = true;
    script.onload = () => {
      let timeKill = setTimeout(() => {
        clearTimeout(timeKill);
        resolve(true); // Carga
      }, 1200);
    };
    script.onerror = reject; // No carga
    document.head.appendChild(script);
  });
};
  
export async function iniciarPagina() {
  return new Promise(async (resolve, reject) => {
    try {
      // 1. Esperamos a que las ofertas se carguen y se pinten en el HTML
        await cargarOfertas()
        .then(()=>{
          // 2. Una vez que la promesa de cargarOfertas se cumple, ejecutamos el evento para btt Mas Informacion
          toggleDetails(); 
          resolve(true);
        }).catch((error)=>{
          console.log(error);
          reject(error);
        })
  
      
      
      console.log("Ofertas cargadas y eventos activados con éxito.");
    } catch (error) {
      console.error("Hubo un error en la secuencia de carga:", error);
    }
  })
}
  
async function cargarOfertas() {
  // fetch devuelve una promesa por defecto
  const respuesta = await fetch('./jsonCardProveedores/proveedores.json');
  const datos = await respuesta.json();
  
  const contenedor = document.getElementById('contenedor-ofertas');
  
  // Mapeamos los datos al HTML (usando tu estructura)
  contenedor.innerHTML = datos.map(oferta => 
  {
    const partesPrecio = oferta.price.split('.');
    const entero = partesPrecio[0];
    const decimal = partesPrecio[1] ? `.${partesPrecio[1]}` : '';
    let arrOfertaExtra = oferta.extraInfo;
    // Generar el HTML de las ofertas extra basado en la imagen
    const ofertasExtraHTML = arrOfertaExtra.map(extra => `
      <div class="plan-card">
        <h4 class="plan-title">${extra.extra_title}</h4>
        
        <div class="plan-speed">${extra.extra_subtitle}</div>
        
        <div class="plan-price">
          $${extra.extra_price}<span class="price-period">/mes</span>
        </div>
        
        <ul class="plan-features">
          <li>
            <span class="feature-icon"></span>
            <span class="feature-text">${extra.extra_desc_1}</span>
          </li>
          <li>
            <span class="feature-icon"></span>
            <span class="feature-text">${extra.extra_desc_2}</span>
          </li>
          <li>
            <span class="feature-icon"></span>
            <span class="feature-text">${extra.extra_desc_3}</span>
          </li>
        </ul>
        
        <a 
          href="tel:123456789" 
          class="btn-llamanos drp-phone"
          data-provider_oferta="${extra['data-provider']}"
          data-title_oferta="${extra['data-title']}"
          data-velocity_oferta="${extra['data-velocity']}"
          data-price_oferta="${extra['data-price']}"
          >${extra.extra_btt}</a>
      </div>
    `).join('');
    
    return `
    <div class="card">
      <div class="offer-title">
          <h3>${oferta.title}</h3>
          <p>${oferta.desc}</p>
      </div>
      <div class="card-body">
          <div class="card-header ${oferta.bgClass}">
              <img src="${oferta.logo}" alt="Logo">
          </div>
          <div class="features-grid">
              <div class="feature-col desktop-only">
                  <h3>Descomplicate</h3>
                  <p>${oferta.features.descomplicate}</p>
              </div>
              <div class="feature-col desktop-only">
                  <h3>Navega</h3>
                  <p>${oferta.features.navega}</p>
              </div>
              <div class="feature-col">
                  <h3>Disfruta</h3>
                  <p>${oferta.features.disfruta}</p>
              </div>
          </div>
          <div class="card-footer">
              <div class="pricing-container">
                    <span class="periodBegin">Desde</span>
                    <span class="amount">
                        $${entero}<span class="decimal">${decimal}</span><span class="period">/mes.</span>
                    </span> 
                </div>
                <div class="buttons-container">
                    <a 
                      href="tel:${oferta.phone}" 
                      class="btn-call drp-phone"
                      data-provider="${oferta['data-provider']}"
                      data-offer="${oferta['data-offer']}"
                    >Llama ya</a>
                    
                </div>
          </div>
      </div>
      <div class="details-hidden" style="display: none;">
          <div class="container_hidden">
              ${ofertasExtraHTML}
          </div>
      </div>
      <button class="btn-info">Más información</button>
    </div>
  `;
  }).join('');
  // La función termina aquí y la promesa se "resuelve"
}
  
// Funcionalidad para desplegar "Más información"
function toggleDetails() {
  const btts = document.querySelectorAll(".btn-info")
  
  btts.forEach(btt => {
    btt.addEventListener("click", ()=>{
      const cardBody = btt.closest(".card");  
      const details = cardBody.querySelector('.details-hidden');
      
      if (details) {
          // Alternar clase 'active' para mostrar/ocultar
          if (details.style.display === "block") {
              details.style.display = "none";
              btt.textContent = "Más información";
          } else {
              details.style.display = "block";
              btt.textContent = "Cerrar";
          }
      } else {
          // Si no hay detalles ocultos en el HTML, alert simple o crear elemento dinámico
          alert("Para más detalles sobre esta oferta, por favor llama al número en pantalla.");
      }
    })
    
  });
  
}
  
document.querySelectorAll('a[href^=""]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});

export function initToggle(){
  const toogleItems = document.getElementsByClassName('elementor-toggle-item');

  for (var i = 0; i < toogleItems.length; i++) {
    const item = toogleItems[i];

    const title = item.querySelector('.elementor-tab-title');
    const content = item.querySelector('.elementor-tab-content');
    title.addEventListener('click', () => {
      if(title.classList.contains('elementor-active')) {
        title.classList.remove('elementor-active');
        content.classList.remove('elementor-active');
      }
      else {
        title.classList.add('elementor-active');
        content.classList.add('elementor-active');
      }
    })
  }
}